module.exports = __webpack_public_path__ + "img/49.31d7a3bb.jpg";